import { Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommUnitLookup extends Layout {
	table1: Table;
}
